import { useNavigate } from "react-router-dom";

import Swal from "sweetalert2";

import DashboardLayout from "../../../components/layout/DashboardLayout";

import { useRepairQuotationViewModel } from "../../../viewmodels/operation/repairquotation/useRepairQuotationViewModel";

const RepairQuotations = () => {
  const navigate = useNavigate();

  const {
    repairQuotations,
    loading,

    page,
    setPage,

    search,
    setSearch,

    deleteRepairQuotation,
  } = useRepairQuotationViewModel();

  const handleDelete = async (id: string) => {
    const result = await Swal.fire({
      title: "Delete Repair Quotation?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#64748b",
      reverseButtons: true,
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      await deleteRepairQuotation(id);

      await Swal.fire({
        icon: "success",
        title: "Deleted",
        text: "Repair quotation deleted successfully.",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch {
      await Swal.fire({
        icon: "error",
        title: "Delete Failed",
        text: "Unable to delete repair quotation.",
      });
    }
  };

  return (
    <DashboardLayout>
      <div className="p-4 md:p-6">
        {/* HEADER */}
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-bold">Repair Quotations</h1>

            <p className="text-gray-500 mt-1">Manage quotations</p>
          </div>

          <button
            onClick={() => navigate("/repair-quotations/create")}
            className="bg-primary text-white px-5 py-3 rounded-2xl"
          >
            + Create
          </button>
        </div>

        {/* SEARCH */}
        <div className="bg-white border rounded-2xl p-4 mb-5">
           <label className="block text-sm font-medium mb-2">Search</label>
          <input
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);

              setPage(1);
            }}
            placeholder="Search..."
            className="w-full border rounded-xl px-4 py-3"
          />
        </div>

        {/* TABLE */}
        <div className="bg-white border rounded-2xl overflow-hidden">
          <table className="w-full">
            <thead className="bg-slate-100">
              <tr>
                <th className="p-3 border">No</th>

                <th className="p-3 border">Customer</th>

                <th className="p-3 border">Date</th>

                <th className="p-3 border">Total</th>

                <th className="p-3 border">Actions</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={5} className="text-center p-6">
                    Loading...
                  </td>
                </tr>
              ) : repairQuotations.length === 0 ? (
                <tr>
                  <td
                    colSpan={6}
                    className="text-center p-8 border border-slate-200 text-gray-500"
                  >
                    No records found
                  </td>
                </tr>
              ) : (
                repairQuotations.map((x: any) => (
                  <tr key={x.id}>
                    <td className="p-3 border">{x.no}</td>

                    <td className="p-3 border">{x.customerName}</td>

                    <td className="p-3 border">
                      {x.date
                        ? new Date(x.date).toLocaleDateString("en-GB")
                        : "-"}
                    </td>

                    <td className="p-3 border">${x.total}</td>

                    <td className="p-3 border">
                      <div className="flex gap-2">
                        <button
                          onClick={() =>
                            navigate(`/repair-quotations/view/${x.id}`)
                          }
                          className="bg-blue-500 text-white px-3 py-2 rounded-lg"
                        >
                          View
                        </button>

                        <button
                          onClick={() =>
                            navigate(`/repair-quotations/edit/${x.id}`)
                          }
                          className="bg-yellow-500 text-white px-3 py-2 rounded-lg"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDelete(x.id)}
                          className="bg-red-500 hover:bg-red-600 text-white px-3 py-2 rounded-lg transition"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* PAGINATION */}
        <div className="mt-4 flex items-center justify-between gap-3">
          <button
            disabled={page === 1}
            onClick={() => setPage((p: number) => Math.max(1, p - 1))}
            className="px-4 py-2 border rounded-xl disabled:opacity-50"
          >
            Prev
          </button>

          <span className="text-sm font-medium">Page {page}</span>

          <button
            onClick={() => setPage(page + 1)}
            className="px-4 py-2 border rounded-xl"
          >
            Next
          </button>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default RepairQuotations;
